<template>
    <div class="m-viewport" v-if="ready">

        <div class="logos">
            <h1 class="logo"><a class="logo_1" href="http://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h1>
        </div>

        <div class="m-top">
            <div class="u-link index"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></div>
            <div class="u-link dl"><a href="https://www.m3guo.com/v2/download/client/" target="_blank" rel="noopener noreferrer"></a></div>
        </div>

        <user-info class="user-info"/>

        <div class="main-view">
            
            <web_share/>
            <invite class="the-invite"/>
            <task class="the-task"/>
            <pass class="the-pass" ref="pass"/>
            <update class="the-update"/>
            <rule class="the-rule"/>
        </div>

    </div>
</template>

<style scoped>
.m-viewport{
    position: relative;
    min-width: 1400px;
    max-width: 1920px;
    /* max-height: 7500px; */
    height: 6648px;
    margin: 0 auto;
    padding-top: 758px;
    /* overflow: hidden; */
    overflow-x: hidden;
    background-image: url(~@/assets/images/pc/body.jpg);
    background-position: center -42px;
    background-repeat: no-repeat;    
    background-color: #222229;
    box-sizing: border-box;        
}

.m-top{
    position: absolute;
    right: 95px;
    top:68px;
    display: flex;
    align-items: center;    
}

.u-link{
    width: 41px;
    height: 41px;
    margin: 0 10px;
}

.u-link a{
    display: block;
    width: 100%;
    height: 100%;
}

.u-link.dl{
    background-image: url(~@/assets/images/pc/btn-dl.png);
}

.u-link.index{
    background-image: url(~@/assets/images/pc/btn-index.png);
}

.logos{
    position: absolute;
    left: 95px;
    top: 42px;
    display: flex;
    align-items: center;
}

h1.logo{
    width: 124px;
    height: 98px;
    background-image: url(~@/assets/images/pc/logo.png);
}

h1.logo a{
    display: block;
    width: 100%;
    height: 100%;
}

.user-info{
    width: 100%;
    height: 37px;
    line-height: 37px;
    margin-bottom: 150px;
    font-size: 16px;
    color: #ffffff;
    background-image: url(~@/assets/images/pc/bg-user.png);
    background-repeat: no-repeat;
    background-position: center;
}

.main-view{
    /* width: 1070px; */
    margin: 0 auto;
}

.the-invite{
    margin-top: 160px;
}

.the-task{
    margin-top: 180px;
}

.the-pass{
    margin-top: 130px;
}

.the-update{
    margin-top: 70px;
}

.the-rule{
    margin-top: 80px;
}
</style>

<script>
import web_share from '@/view/webshare';
import task from '@/view/task';
import invite from '@/view/invite';
import pass from '@/view/pass';
import update from '@/view/update';
import rule from '@/view/rule';

export default {
    components: {
        web_share,
        task,
        invite,
        pass,
        update,
        rule,
    },
    props : {
      ready : {
          default : false,
      },                           
    },
    mounted(){
        this.get_task_info();
    },
    methods : {
        get_task_info (){
            let _this = this;
            _this.$get(ajax_url_map.task_info,{
                success : (res) => {
                    _this.$store.commit("$_setTask", res.data);
                    console.log(_this.$store.state.task);
                },
                error : (data)=> {

                },
            });
        },
    },          
}
</script>


// WEBPACK FOOTER //
// src/page/index/index.vue